(() => {
  const forms = document.querySelectorAll('[data-gift-request-form]');

  const buildSubmissionTags = (form) => {
    const baseTags = (form.dataset.giftRequestBaseTags || 'gift_request')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
    const productHandle = form.dataset.giftRequestProductHandle || 'produto';
    const submissionTag = `gift_request_submit__${productHandle}__${Date.now()}`;

    return [...new Set([...baseTags, submissionTag])].join(',');
  };

  forms.forEach((form) => {
    const tagsInput = form.querySelector('[data-gift-request-tags]');
    const consentInput = form.querySelector('[data-gift-request-consent]');

    const validateConsent = () => {
      if (!consentInput) return;

      consentInput.setCustomValidity(
        consentInput.checked ? '' : consentInput.dataset.validationMessage || 'Confirme a autorizacao.'
      );
    };

    consentInput?.addEventListener('change', validateConsent);
    validateConsent();

    form.addEventListener('submit', () => {
      validateConsent();

      if (tagsInput) {
        tagsInput.value = buildSubmissionTags(form);
      }
    });
  });
})();
